import React, { Component } from 'react';
import { Modal, Steps, Button, message } from 'antd';
const Step = Steps.Step;

class DriverModal extends Component {
  constructor(props) {
    super(props);
    this.steps = {step0: {name: false, phone: false}, step1: {license: false}};
    this.state = {step: 0, stepLimit: 1, stepValidation: this.steps, driver: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handleName = this.handleName.bind(this);
    this.handlePhone = this.handlePhone.bind(this);
    this.handleLicense = this.handleLicense.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.validateStep)
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.driver);
      this.setState({validation: true, step: 0, driver: {}});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  validateStep() {
    let steps = 0;
    let total = 0;
    for(let item in this.state.stepValidation[`step${this.state.step}`]) {
      if(this.state.stepValidation[`step${this.state.step}`][item]) {
        steps += 1;
      }
      total += 1;
    }
    
    if(steps === total) {
      return true;
    } else {
      return false;
    }
  }

  handleName(event) {
    this.setProp('name', event.target.value);
    this.setState({validation: true});
  }

  handlePhone(event) {
    this.setProp('phone', event.target.value);
    this.setState({validation: true});
  }

  handleLicense(event) {
    this.setProp('license', event.target.value);
    this.setState({validation: true});
  }

  setProp(prop, value) {
    let driver = this.state.driver;
    let validation = this.state.stepValidation;
    driver[prop] = value;
    
    // Update validation
    if(String(value).length > 0) {
      validation[`step${this.state.step}`][prop] = true;
    } else {
      validation[`step${this.state.step}`][prop] = false;
    }
    
    this.setState({driver: driver, stepValidation: validation});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Nombre" />
            <Step title="Licencia" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          {/* Step 1 */}
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Nombre</label>
              <input type="text" className="form-control" defaultValue={this.props.current.name} placeholder="Nombre de conductor" onChange={this.handleName} />
            </div>

            <div className="form-group">
              <label>Teléfono</label>
              <input type="text" className="form-control" defaultValue={this.props.current.phone} placeholder="Teléfono celular con LADA" onChange={this.handlePhone} />
            </div>
          </div>

          {/* Step 2 */}
          <div style={{ width: '100%', display: this.showStep(1) }}>
            <div className="form-group">
              <label>Licencia de conducir</label>
              <input type="text" className="form-control" defaultValue={this.props.current.license} placeholder="ABC102..." onChange={this.handleLicense} />
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default DriverModal;



// WEBPACK FOOTER //
// ./src/components/modals/DriverModal.js